export default "__VITE_ASSET__BPfB0lQe__"